import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [
    { src: '/public/assets/fonts/Roboto-Regular.ttf', fontWeight: 'normal' },
    { src: '/public/assets/fonts/Roboto-SemiBold.ttf', fontWeight: 'bold' },
  ],
});

export const styles = StyleSheet.create({
  page: {
    padding: '10px 20px',
    fontFamily: 'Roboto',
    fontSize: 7,
  },
  pagePcProcess: {
    padding: '35px 10px',
    fontFamily: 'Roboto',
    fontSize: 7,
  },
  pageReport: {
    padding: '40px 25px',
    fontFamily: 'Roboto',
    fontSize: 8,
  },
  container: {
    margin: 15,
  },
  table: {
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableCell: {
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: 'black',
    padding: 2,
    flex: 1,
    justifyContent: 'center',
  },
  tableCell_tight: {
    borderWidth: 1,
    borderColor: 'black',
    padding: 0.5,
    flex: 0.4,
  },
  tableCell_logo: {
    borderWidth: 1,
    borderColor: 'black',
    padding: 0,
    flex: 0.3,
  },
  logo_last: {
    width: 80,
    height: 80,
  },
  tableCell_content: {
    borderWidth: 1,
    borderColor: 'black',
    padding: 0,
    flex: 1.0,
  },
  centerContent: {
    textAlign: 'center',
  },
  centerLeft: {
    textAlign: 'left',
  },
  centerRight: {
    textAlign: 'right',
  },
  bold: {
    fontWeight: 'bold',
  },
  lGreyBg: {
    backgroundColor: '#c0c0c0',
  },
  logo1: {
    width: 115,
    height: 50,
    paddingLeft: 50
  },
  logo2: {
    width: 100,
    height: 35,
    paddingRight: 10
  },
  logo3: {
    width: 100,
    height: 35,
    paddingLeft: 10
  },
  PCProcesslogo1: {
    width: 135,
    height: 300,
    paddingLeft: 30,
  },
  PCProcesslogo2: {
    width: 84,
    height: 32,
  },
  PCProcesslogo3: {
    width: 120,
    height: 40,
    paddingLeft: 10,
  },
  logo: {
    width: 80,
    height: 60,
  },
  width_10: {
    width: 1,
  },
  border_bottom_0: {
    borderBottom: 0,
    borderLeft: 0,
    borderRight: 0,
  },
  border_right: {
    borderRight: 0,
  },
  border_Right: {
    borderRight: 1,
    borderColor: '#000'
  },
  heading1: {
    fontSize: 9.5,
    fontWeight: 'bold',
    borderBottom: 0,
  },
  heading4: {
    fontSize: 8,
    fontWeight: 'normal',
    borderTop: 0,
  },
  textAlignLeft: {
    textAlign: 'left',
  },
  smallLogo: {
    width: 10,
    height: 10,
    marginLeft: '5px',
  },
  checkboxAll: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    // marginTop:'3px',
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    // marginLeft: '5px',
  },
  imgContent: {
    fontSize: '8px',
  },

  lasttable: {
    flexDirection: 'row',
    borderBottomColor: '#000',
    border: 1,
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  lasttableRow: {
    flexDirection: 'row',
    width: '100%',
    borderBottomColor: '#ddd',
    borderBottomWidth: 1,
  },
  lasttableCellLeft: {
    width: '30%',
    paddingTop: 10,
    paddingLeft: 6,
    borderRightWidth: 1,
  },
  lasttableCellCenter: {
    width: '20%',
    paddingTop: 32,
    paddingLeft: 6,
    borderRightWidth: 1,
  },
  lasttableCellRight: {
    width: '26%',
    paddingTop: 67,
    paddingLeft: 6,
    borderRightWidth: 1,
  },
  lasttableEmptyCell: {
    width: '24%',
    paddingTop: 40,
    borderRightWidth: 1,
  },
  PCProcesslasttableCellLeft: {
    width: '30%',
    paddingTop: 20,
    borderRightWidth: 1,
  },
  PCProcesslasttableCellCenter: {
    width: '20%',
    paddingTop: 10,
    paddingLeft: 10,
    borderRightWidth: 1,
  },
  PCProcesslasttableCellRight: {
    width: '26%',
    paddingTop: 80,
    paddingLeft: 6,
    borderRightWidth: 1,
  },
  PCProcesslasttableEmptyCell: {
    width: '24%',
    paddingTop: 19,
    borderRightWidth: 1,
  },

  tableCell_25: {
    width: '25%',
    borderWidth: 1,
    borderColor: 'black',
    padding: 2,
    flexGrow: 0, // Prevent flex growth
  },
  tableCell_title: {
    width: '50%',
    borderWidth: 1,
    borderColor: 'black',
    padding: 2,
    flexGrow: 0, // Prevent flex growth
  },
  tableCell_15: {
    width: '18%',
    borderWidth: 1,
    borderColor: 'black',
    padding: 2,
    flexGrow: 0,
  },
  tableCell_35: {
    width: '35%',
    borderWidth: 1,
    borderColor: 'black',
    padding: 2,
    flexGrow: 0,
  },
  tableCell_filedBy: {
    width: '45%',
    height: 13,
    borderWidth: 1,
    borderColor: 'black',
    padding: 1,
  },
  image_row: {
    flexDirection: 'row',
    border: 1,
    justifyContent: 'space-between',
  },
  image_headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    height: 15,
    alignItems: 'center',
  },
  image_headerText: {
    fontSize: 7,  
    fontWeight: 'bold',
    textAlign: 'center',
    flex: 1,
  },
  image_beforeHeader: {
    color: '#0044cc', // Dark Blue
    paddingLeft: 110,
  },
  image_afterHeader: {
    color: '#009933', // Dark Green
    paddingLeft: 110,
  },
  image_column: {
    flex: 1,
    alignItems: 'center',
  },
  image_imageWrapper: {
    marginVertical: 10,
  },
  image_beforeImage: {
    width: 130,
    height: 100,
  },
  image_afterImage: {
    width: 130,
    height: 100,
  },
  image_Signature : {
    width: 90,
    height: 100,
  },
  sectionTitle: {
    fontSize: 14,
    marginBottom: 8,
    fontWeight: 'bold',
  },
  fullBorder: {
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderLeftColor: '#000',
    borderRightColor: '#000',
    borderBottomColor: '#000',
  },
  headerRow: { flexDirection: 'row', width: '100%' },
  headerCell: { flex: 1, textAlign: 'center', fontWeight: 'bold', fontSize: 14, padding: 6 },
  // Row 1: Yellow background
  headerRow1: { backgroundColor: '#FFC000', color: '#000' },
  // Row 2: Light gray background
  headerRow2: { backgroundColor: '#D9D9D9', color: '#000' },
  // Row 3: Dark gray background, white text
  headerRow3: { backgroundColor: '#7B7B7B', color: '#fff' },
    section: {
    marginBottom: 6,
  },
  row: {
    flexDirection: 'row',
    borderBottom: '1 solid #ccc',
  },
  cell: {
    border: '1 solid #000',
    padding: 2,
    flexGrow: 1,
  },
  header: {
    fontSize: 10,
    marginBottom: 5,
    fontWeight: 'bold',
  },
  title: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 10,
  },
  checkboxGroup: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  checkboxLabel: {
    marginRight: 5,
  },
  remarksBox: {
    borderTopWidth: 0,
    borderWidth: 1,
    borderColor: '#000',
    backgroundColor: '#ffffffff',
  },
  headerRow0: {
    backgroundColor: '#3A3A3A', // dark gray header
  },
  evenRow: {
    backgroundColor: '#F5F5F5', // light gray even rows
  },
  oddRow: {
    backgroundColor: '#FFFFFF', // white odd rows
  },
    highlightCell: {
    backgroundColor: '#EFEFEF', // slightly lighter for certain cells
  },
  labelText: {
    fontWeight: 'bold',
    fontSize: 10,
    color: '#000000',
  },
  valueText: {
    fontSize: 10,
    color: '#000000',
  },
  headerText: {
    color: '#FFFFFF',
    fontWeight: 'bold',
    fontSize: 11,
  },
  doubleSignatureRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 15,
    borderWidth: 1,
    borderColor: '#000',
    padding: 10,
  },
  halfColumn: {
    flex: 1,
    paddingRight: 10,
  },
  singleSignatureRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderWidth: 1,
    borderColor: '#000',
    padding: 10,
  },
  fullWidthColumn: {
    flex: 1,
    paddingRight: 10,
  },
  pageLTO: {
    padding: 15,
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  containerLTO: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  labelBoxLTO: {
    width: '48%',
    height: '24%',
    border: '1px solid black',
    padding: 10,
    marginBottom: 10,
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'flex-start',
  },
  logoRowLTO: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 5,
    marginBottom: 5,
  },
  logoLTO: {
    width: 200,
    height: 40,
    marginHorizontal: 5,
  },
  ltoCode: {
    fontSize: 12,
    marginBottom: 5,
    marginTop: 5
  },
  filmTitle: {
    fontSize: 11,
    marginBottom: 5,
    marginTop: 5
  },
  formatList: {
    fontSize: 10,
    lineHeight: 1.5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    marginTop: 5,
  },
});